/**
 * 무빈소 절차 퍼널 E4 개편(신뢰 구간) 실험.
 *
 * 무엇을 하는 실험인가
 * - `/match/request?template=mubinso` 첫 화면에서 배정한다(Hackle 369).
 * - A: 현행(Q1 → Q2 상황 → 퍼널, 실험 330 채택안)
 * - B: 첫 화면에 Q1 버튼 + 급한 고객 버튼, Q2 없이 절차 · 비용 · 장례식장 E4 퍼널(신뢰 구간 추가).
 *   상황은 리드 폼에서 받는다.
 * - 명세: wiki/plans/mubinso-funnel-trust.md
 *
 * M5 가족장 광고그룹(A·B 소재 모두, `isFamilyAdGroup`)과 `?template=family` 는 이 실험에
 * 배정하지 않고 현행 A 를 본다(가족장 A/B 의 비교군이 현행이어야 한다, PR #2728).
 * 그 경로에서 getVariationOnDemand 를 부르면 노출이 찍혀 모수가 섞인다.
 */

/**
 * Hackle experimentKey.
 *
 * Hackle 콘솔에서 만든 369 를 확인하고 넣었다(2026-11-02).
 * 미리 "다음 번호"를 적어 두면 남의 실험 분모를 오염시킨다(#333 사고). 0 이면 배정하지 않고 모두 현행 A 를 본다.
 */
export const MUBINSO_PROCEDURE_E4_EXPERIMENT_KEY = 369;
